<template>
  <div class="wrap">
    <Navbar background="transparent" fixed />
    <div class="icon_lang" @click="showLang">
      <img :src="require('../../assets/new/mine/language.png')" class="langicon" alt="">
      <span>{{ langtext }}</span>
    </div>
    <!-- <ServiceBtn textShow /> -->
    <!-- 
    <div class="deline">
      <div class="left"></div>
      <div class="text">{{ $t("partner") }}</div>
      <div class="right"></div>
    </div>
    <div class="partners">
      <img :src="require(`@tt/assets/login/patner/all.png`)" alt="" class="partner_img">
    </div> -->
    <div class="form_wrap_bar">
      <div class="logo">
        <img :src="require('@/assets/logo/login.png')" class="logo_img" alt="" />
      </div>
      <LoginForm :formList="formList" cancelText="Login.registrasi" confirmText="newAdd.Login" readText="记住"
        :getRemember="true" @cancel="toRegiste" @submit="onSubmit" isRead>
      </LoginForm>
      <div class="already_account">
        <span>{{ $t("没有账号") }}</span>
        <span @click="toRegiste" class="register">{{ $t("page.registrasi") }}</span>
      </div>
    </div>

    <van-action-sheet v-model="show2" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import { Icon, Image as VImg, Toast, ActionSheet } from "vant";
import LoginForm from "./components/form.vue";
import Cookies from "js-cookie";
import { SEND_SMS_CODE, LOGIN } from "@/api";
import { getNewPhone } from "@/utils/tools";
import ServiceBtn from "@/components/serviceBtn";
import verConfig from "@/utils/verConfig";
import { $post } from "../../utils/request";
import { Lans, getLanguage } from "@/i18n";
export default {
  components: {
    Icon,
    VImg,
    [ActionSheet.name]: ActionSheet,
    LoginForm,
    ServiceBtn,
    Navbar,
  },
  data() {
    this.Lans = Lans;
    return {
      langicon: "",
      langtext: "",
      show2: false,
      formList: [
        {
          key: "userphone",
          flag: true,
          // icon: "icon-yonghuming",
          label: "Login.nameInput",
          rules: [{ required: true, message: this.$t("hint.usernameEnter") }],
          needTrue: true
        },
        {
          label: "Login.pwdInput",
          type: "password",
          key: "userpass",
          // icon: "icon-zhanghumima",
          flag: true,
          rules: [{ required: true, message: this.$t("hint.passwordEnter") }],
          isPassword: true,
        },
      ],
    };
  },
  created() {
    Lans.forEach((item) => {
      if (item.value == getLanguage()) {
        this.langicon = item.icon;
        this.langtext = item.name;
      }
    });
  },
  methods: {
    onSubmit(values, read) {
      Toast.loading({ duration: 0 });
      LOGIN({...values}) // http请求
        .then((r) => {
          if (r.data.ret === 1) {
            this.$cookie.set("userInfo", JSON.stringify(r.data.data));
            this.$cookie.set("token", r.data.data.token);
            this.$cookie.set("the-pwd-state", this.checked);
            if (read) {
              this.$cookie.set(
                "the-pwd-obj",
                JSON.stringify({
                  userphone: values.userphone,
                  userpass: values.userpass,
                })
              );
            } else {
              this.$cookie.remove("the-pwd-obj");
            }
          } else {
            Toast.clear();
            Toast(r.data.msg);
          }
          return r.data.ret;
        })
        .then(async (ret) => {
          if (ret == 1) {
            this.$store.dispatch("getSystemConfig");
            try {
              const res = await $post("/users/info");
              const { ret, msg, data } = res.data;
              if (ret == 1) {
                // this.LoadingShow = false;
                Toast.clear();
                this.$router.replace({ name: "goods" });
                this.$cookie.set("userInfo", JSON.stringify(data));
              }
            } catch (error) {
              console.error("登录错误", error);
              Toast.clear();
            }
          }
        })
        .catch((e) => {
          Toast.clear();
          console.log(e);
        });
    },
    toRegiste() {
      this.$router.push("/registrasi");
    },
    showLang() {
      this.show2 = true;
    },
    onClose() {
      this.show2 = false;
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value);
      Cookies.set("lang", e.value);
      this.language = e.value;
      this.show2 = false;
      this.langicon = e.icon;
      this.langtext = e.name;
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: var(--bg);
  min-height: 100vh;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url("../../assets/login/bg.png");
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/ .service_btn {
    position: fixed;
    top: calc(26rem / 16);
    right: calc(20rem / 16);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .icon_lang {
    position: fixed;
    top: calc(26rem / 16);
    right: calc(20rem / 16);
    height: calc(60rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      height: 36px;
      width: 36px;
      object-fit: contain;
      // margin-right: 8%;
    }

    span {
      // min-width: 55px;
      color: #fff;
      font-size: calc(14rem / 16);
    }
  }

  .deline {
    padding: 0 calc(17rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: calc(30rem / 16);
    color: var(--light);

    .left {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 1));
    }

    .text {
      margin: 0 calc(10rem / 16);
    }

    .right {
      .left();
      background: linear-gradient(90deg,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0));
    }
  }

  .partners {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: calc(15rem / 16) calc(17rem / 16) calc(15rem / 16);

    >.partner_img {
      // height: 60px;
      width: 100%;
    }
  }

  .form_wrap_bar {
    width: 90%;
    background-color: #470707;
    padding: calc(32rem / 16) 0 calc(23rem / 16);
    border-radius: 8px;

    .logo {
      display: flex;
      justify-content: center;

      &_img {
        height: calc(60rem / 16);
        display: block;
      }
    }
  }

  .nav {
    // height: calc(50rem / 16);
    color: var(--textColor);
    display: flex;
    align-items: center;
    margin: calc(26rem / 16) calc(17rem / 16) 0;

    .back {
      transform: rotate(90deg);
    }

    .title {
      font-size: calc(24rem / 16);
      margin-left: calc(14rem / 16);
    }
  }

  .already_account {
    text-align: center;
    color: var(--light);
    font-size: calc(14rem / 16);
    margin-top: calc(15rem / 16);
    white-space: pre-wrap;

    .register {
      color: var(--yellow);
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
